module.exports = __webpack_public_path__ + "static/img/13.cd8d216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/裤子/13.png
// module id = zw0f
// module chunks = 0